import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, s = ({ size: t = 16, useVw: n, useRem: o, color: c, withColor: i, removeClassName: e, disableSSR: h, style: l, ...m }) => {
  const p = l ? { ...d, ...l } : d;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: h }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-xinshouyindao", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (o ? "rem" : "px"), height: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (o ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: p, fill: "none", ...m }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: e ? "" : "32px-æ°æå¼å¯¼"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: e ? "" : "normal",
        fill: i ? r(c, 0, "#262933") : "#262933",
        datafollowfill: i ? r(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M18.708 12.857a.9.9 0 0 1 .9-.9h3.11a.9.9 0 0 1 0 1.8h-3.11a.9.9 0 0 1-.9-.9Zm.9 3.136a.9.9 0 0 0 0 1.8h1.473a.9.9 0 0 0 0-1.8h-1.473Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M3.5 7.83a3.273 3.273 0 0 1 3.273-3.272h4.71c1.893 0 3.557.976 4.517 2.453a5.377 5.377 0 0 1 4.516-2.453h4.711A3.273 3.273 0 0 1 28.5 7.83v15.508a4.09 4.09 0 0 1-4.09 4.091H7.59a4.09 4.09 0 0 1-4.09-4.09V7.83Zm3.273-1.472c-.814 0-1.473.659-1.473 1.472v15.508a2.29 2.29 0 0 0 2.29 2.291h7.475V9.94a3.582 3.582 0 0 0-3.581-3.581H6.773Zm18.454 0h-4.71a3.582 3.582 0 0 0-3.582 3.581v15.69h7.474a2.29 2.29 0 0 0 2.291-2.29V7.83c0-.813-.66-1.472-1.473-1.472Z"
        }
      )
    )
  )));
}, v = s;
export {
  v as default
};
